// displaySchemaFields.js

import { getResolvedFields } from 'utilities/NodeType';
import {
  isClickUpOriginDetailsField,
  isOriginTitleMappedField,
  isSchemaFieldHiddenFromDisplay,
} from 'utilities/schemaFieldVisibility';
import { isTableIgnoredFieldKey } from 'views/utils/tableIgnoredFields';

export const isSecuredSchemaField = (field) => Boolean(field?.secured);

export const filterSecuredSchemaFields = (fields = []) => (
  (Array.isArray(fields) ? fields : []).filter((field) => !isSecuredSchemaField(field))
);

/**
 * Resolves schema fields for base/customer-facing display.
 * Secured fields are internal and excluded from all view UIs.
 */
export const resolveDisplaySchemaFields = (typeDef, { includeHidden = true } = {}) => {
  if (!typeDef) return [];

  if (Array.isArray(typeDef?.schema?.fields) && typeDef.schema.fields.length) {
    return typeDef.schema.fields
      .filter((field) => {
        if (!field?.name || !field.type) return false;
        if (!includeHidden && isSchemaFieldHiddenFromDisplay(field)) return false;
        if (field.secured) return false;
        // Origin primary/name → node.title; never render a duplicate Title/Name field.
        if (isOriginTitleMappedField(field, typeDef)) return false;
        // ClickUp assignees → origin details below the form.
        if (isClickUpOriginDetailsField(field, typeDef)) return false;
        return true;
      })
      .map((field) => {
        const copy = { ...field };
        if (!copy.source && typeDef.key) copy.source = typeDef.key;
        delete copy.inherited;
        return copy;
      });
  }

  if (typeDef?.key) {
    return getResolvedFields(typeDef.key, { includeHidden, excludeSecured: true });
  }

  return [];
};

export const filterDisplayFieldKeys = (keys = [], schemaFieldMap = null) => (
  (Array.isArray(keys) ? keys : []).filter((key) => {
    const normalized = String(key || '').trim();
    if (!normalized || isTableIgnoredFieldKey(normalized)) return false;

    if (schemaFieldMap instanceof Map) {
      const fieldDef = schemaFieldMap.get(normalized);
      if (isSecuredSchemaField(fieldDef)) return false;
    }

    return true;
  })
);
